export const RESTORE_CONTENT = 'RESTORE_CONTENT';
export const restoreContent = id => ({ type: RESTORE_CONTENT, id });
